"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayControl = void 0;
var GameplayControl;
(function (GameplayControl) {
    GameplayControl["PresentQuestion"] = "PRESENT_QUESTION";
    GameplayControl["Pending"] = "PENDING";
    GameplayControl["PresentAnswerWithCorrectResponse"] = "PRESENT_ANSWER_WITH_CORRECT_RESPONSE";
    GameplayControl["PresentAnswerWithIncorrectResponse"] = "PRESENT_ANSWER_WITH_INCORRECT_RESPONSE";
})(GameplayControl || (exports.GameplayControl = GameplayControl = {}));
